import { Account, AccountLOB } from '@ally/data-types-afg-accounts'

/**
 * Sorts wealth accounts based on accountNumber ensuring
 * consistent account order
 * TODO: Update to sort by account date once that property is available
 */
export const sortWealthAccountsGroup = (accounts: Account[]): Account[] => {
  return accounts.sort((accountA, accountB) => {
    return accountA.accountNumber.localeCompare(accountB.accountNumber)
  })
}

export function getSortedInvwAccountsWithOverview(
  accounts: Account[],
): Account[] {
  const overview = {
    name: 'Wealth Overview',
    lob: AccountLOB.WEALTH,
    id: 'wealth-overview',
  } as Account
  return [overview, ...accounts]
}
